import { CustomerUserAPI } from "../api";

export class CustomerUser {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }

  static async getCustomerUserByProject(payload, user) {
    const { data } = await CustomerUserAPI.getCustomerUserByProject(payload, user);
    return data.result.map(item => new CustomerUser(item));
  }

 }
